import Korg from 'reed-korg'
import BaseComponent from './_BaseComponent'



/* OVERLAY TOPICS
----------------------------------------------------------------------------------------------------*/

export default class Overlay extends BaseComponent {

    constructor($el, namespace) {
        super('Overlay', $el, namespace)

        this.on()
    }


    bindProperties() {
        this.isOpen = false
        this.leaveTimer = null
        this.isAfter = null

        this.scrollArea = new Korg(this.$refs.scrollArea[0])
    }


    bindHandlers() {
        this.clickHandler = e => this.onClick(e)
        this.closeClickHandler = e => this.onCloseClick(e)

        this.keydownHandler = e => this.onKeydown(e)
        this.scrollHandler = () => this.onInnerScroll()

        this.pageWillChangeHandler = () => { this.onPageWillChange() }
    }


    bindEvents() {
        const { $openBtn, $closeBtn, $scrollArea } = this.$refs

        this.addListeners(
            [$openBtn, 'click', this.clickHandler],
            [$closeBtn, 'click', this.closeClickHandler],

            [document, 'pageWillChange', this.pageWillChangeHandler],
            [document, 'keydown', this.keydownHandler],

            [$scrollArea, 'scroll', this.scrollHandler],
        )
    }




    /* Handlers
    --------------------------------------------------------- */


    onInnerScroll() {
        const { $scrollArea, $panel } = this.$refs
        const isAfter = $scrollArea[0].scrollTop > 50

        if (isAfter === this.isAfter) return

        this.isAfter = isAfter

        $panel.toggleClass('is-after', isAfter)
    }



    onKeydown(e) {
        if (!this.isOpen || e.code !== 'Escape') return

        this.forceClose()
    }


    onClick(e) {
        this.toggle()
    }


    onCloseClick(e) {
        this.toggle(false)
    }


    onPageWillChange() {
        this.toggle(false)
    }




    /* Actions
    --------------------------------------------------------- */


    toggle(shouldOpen = !this.isOpen) {
        if (shouldOpen === this.isOpen) return

        const { $doc } = this.$utils
        const { $panel, $openBtn, $scrollArea } = this.$refs

        this.scrollArea.toggle(shouldOpen)
        $panel.toggleClass('is-focused', shouldOpen)
        $openBtn.attr('aria-expanded', shouldOpen)
        $doc.trigger('overlayToggled', { isOpen: shouldOpen, trigger: 'topics' })


        this.isOpen = shouldOpen


        if (this.isOpen) {
            $scrollArea[0].scrollTop = 0
            $panel[0].focus()
        } else {
            document.activeElement.blur()
            $panel.removeClass('is-after')
        }
    }


    forceClose() {
        this.toggle(false)
    }



}



